import { HStack, Text } from '@chakra-ui/react';

import { formatHelpers } from '@nocowanie/core';

import { RemainingPriceProps } from './remaining-price.props';

export const RemainingPrice = ({
    currency,
    remainingPrice,
    withConvertedPrice,
    convertedCurrency,
    remainingConvertedPrice,
    ...props
}: RemainingPriceProps) => (
    <HStack gap={1}>
        <Text as={'span'}>{formatHelpers.price(remainingPrice, currency as string)}</Text>
        {withConvertedPrice && remainingConvertedPrice && convertedCurrency ? (
            <Text as={'span'} fontSize={props.fontSize}>
                {`(∼${formatHelpers.price(remainingConvertedPrice, convertedCurrency as string)})`}
            </Text>
        ) : (
            ''
        )}
    </HStack>
);
